"use strict";
/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const TableauAskData_1 = require("./EmbeddingApi/Components/TableauAskData");
const TableauAuthoringViz_1 = require("./EmbeddingApi/Components/TableauAuthoringViz");
const TableauViz_1 = require("./EmbeddingApi/Components/TableauViz");
const isAlpha = typeof VERSION_IS_ALPHA !== 'undefined' ? VERSION_IS_ALPHA : false;
api_shared_js_1.ApiVersion.SetVersionNumber(typeof API_VERSION_NUMBER !== 'undefined' ? API_VERSION_NUMBER : '0.0.0', isAlpha);
window.customElements.define('tableau-viz', TableauViz_1.TableauViz);
window.customElements.define('tableau-authoring-viz', TableauAuthoringViz_1.TableauAuthoringViz);
window.customElements.define('tableau-ask-data', TableauAskData_1.TableauAskData);
const ErrorCodes = Object.assign(Object.assign({}, api_external_contract_js_1.EmbeddingErrorCodes), api_external_contract_js_1.SharedErrorCodes);
exports.ErrorCodes = ErrorCodes;
// Export Enums & Interfaces
var api_external_contract_js_2 = require("@tableau/api-external-contract-js");
exports.AnalyticsObjectType = api_external_contract_js_2.AnalyticsObjectType;
exports.AnnotationType = api_external_contract_js_2.AnnotationType;
exports.ApiMenuType = api_external_contract_js_2.ApiMenuType;
exports.ClassNameKey = api_external_contract_js_2.ClassNameKey;
exports.ColumnType = api_external_contract_js_2.ColumnType;
exports.CrosstabFileFormat = api_external_contract_js_2.CrosstabFileFormat;
exports.DashboardLayoutChange = api_external_contract_js_2.DashboardLayoutChange;
exports.DashboardObjectType = api_external_contract_js_2.DashboardObjectType;
exports.DataType = api_external_contract_js_2.DataType;
exports.DateRangeType = api_external_contract_js_2.DateRangeType;
exports.DeviceType = api_external_contract_js_2.DeviceType;
exports.EncodingType = api_external_contract_js_2.EncodingType;
exports.FieldAggregationType = api_external_contract_js_2.FieldAggregationType;
exports.FieldRoleType = api_external_contract_js_2.FieldRoleType;
exports.FileFormats = api_external_contract_js_2.FileFormats;
exports.FilterDomainType = api_external_contract_js_2.FilterDomainType;
exports.FilterNullOption = api_external_contract_js_2.FilterNullOption;
exports.FilterType = api_external_contract_js_2.FilterType;
exports.FilterUpdateType = api_external_contract_js_2.FilterUpdateType;
exports.HierarchicalLevelSelectionState = api_external_contract_js_2.HierarchicalLevelSelectionState;
exports.IncludeDataValuesOption = api_external_contract_js_2.IncludeDataValuesOption;
exports.MarkType = api_external_contract_js_2.MarkType;
exports.ParameterValueType = api_external_contract_js_2.ParameterValueType;
exports.PeriodType = api_external_contract_js_2.PeriodType;
exports.PrintOrientation = api_external_contract_js_2.PrintOrientation;
exports.PrintPageSize = api_external_contract_js_2.PrintPageSize;
exports.PrintScaling = api_external_contract_js_2.PrintScaling;
exports.QuickTableCalcType = api_external_contract_js_2.QuickTableCalcType;
exports.SelectionUpdateType = api_external_contract_js_2.SelectionUpdateType;
exports.SheetSizeBehavior = api_external_contract_js_2.SheetSizeBehavior;
exports.SheetType = api_external_contract_js_2.SheetType;
exports.SortDirection = api_external_contract_js_2.SortDirection;
exports.TableauDialogType = api_external_contract_js_2.TableauDialogType;
exports.TableauEventType = api_external_contract_js_2.EmbeddingTableauEventType;
exports.Toolbar = api_external_contract_js_2.Toolbar;
exports.TrendLineModelType = api_external_contract_js_2.TrendLineModelType;
var TableauAskData_2 = require("./EmbeddingApi/Components/TableauAskData");
exports.TableauAskData = TableauAskData_2.TableauAskData;
var TableauAuthoringViz_2 = require("./EmbeddingApi/Components/TableauAuthoringViz");
exports.TableauAuthoringViz = TableauAuthoringViz_2.TableauAuthoringViz;
var TableauViz_2 = require("./EmbeddingApi/Components/TableauViz");
exports.TableauViz = TableauViz_2.TableauViz;
//# sourceMappingURL=EmbeddingApi.js.map